import z from "zod";

export const modalGraphicSchema = z
  .object({
    versions: z
      .array(
        z.object({
          versionId: z.string(),
          name: z.string(),
          quantity: z.number(),
          fileSignedId: z.string().optional(),
        })
      )
      .nonempty(),
  })
  .superRefine((step, ctx) => {
    if (!step.versions.some((v) => !!v.fileSignedId)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
      });
    }
  });

// Define Schema Type
export type InferredModalGraphicSchema = z.infer<typeof modalGraphicSchema>;
